export function getRadniNalozi(radniNalozi) {
    return { type: 'GET_RADNI_NALOZI', radniNalozi };
}
